import React from "react";
import { useApp } from "../context/AppContext";
import OkrView from "../components/OkrView";
import { Target } from "lucide-react";

export default function OKR() {
  const { t } = useApp();
  return (
    <div className="p-6 lg:p-8 max-w-[1600px] mx-auto">
      <div className="flex items-center gap-3 mb-2">
        <Target className="w-6 h-6 text-text-secondary" />
        <h1 className="text-3xl font-heading font-medium tracking-tight">{t("okr_title")}</h1>
      </div>
      <p className="text-text-secondary text-sm mb-7">{t("okr_subtitle")}</p>
      <OkrView />
    </div>
  );
}
